var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[_c('navbar',{on:{"nav-click":_vm.handleTO}}),_c('app-main',{attrs:{"current-view":_vm.currentView}}),_c('copyright')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }